import { AxiosError } from 'axios';
import { t } from 'i18next';
import { toast } from 'sonner';
import { ExportApiErrorPayload } from './export.dto';

export const openDownloadUrl = (url: string): void => {
  if (typeof window !== 'undefined') {
    const toast_id = toast.success(t('inbox:export.download_started'), {
      duration: 30_000,
      action: {
        label: t('inbox:export.download'),
        onClick: () => {
          window.open(url, '_blank', 'noopener,noreferrer');
          toast.dismiss(toast_id);
        },
      },
    });
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

export const handleExportFailure = (error: AxiosError<ExportApiErrorPayload>, context: string) => {
  const respData = (error.response?.data ?? {}) as any;

  const rootError = respData?.errors?.root?.[0];
  const rootCode = rootError?.code;

  const message =
    rootCode === 'BAD_REQUEST'
      ? t('inbox:export.errors.noConversations')
      : t('inbox:export.errors.generic');

  toast.error(message, {
    duration: 15_000,
  });
  console.error(context, error);
};
